import React from 'react';
import PropTypes from 'prop-types';

const SrBadge = ({ children }) => (
  <span className='SrBadge'>{children}</span>
);

SrBadge.propTypes = {
  children: PropTypes.node.isRequired,
};

SrBadge.displayName = 'SrBadge';

export default SrBadge;
